import { Reducers } from '@sda/enums/store';
import { PublicBeaconMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import { SDKFactory } from './helpers/sdk.factory';
import type { FirestoreClientData, Sitemap } from './interfaces';
import type { Beacon, BeaconEvent } from '@sda/interfaces/beacon';

/**
 * SDK Class to interact with Firestore Beacons.
 */
export class Beacons extends SDK<Beacon> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.BEACONS);

    this.collection = this.fsh.Schema.PublicBeacons;

    this.PublicMap = PublicBeaconMask;
  }

  /* Public Subcollections */

  BeaconEvents(id: string): SDK<BeaconEvent> {
    return SDKFactory(
      this.fsh.clientData,
      this.fsh.getCollection<BeaconEvent>(this.fsh.Schema.PublicBeacons, id, 'BeaconEvents'),
    );
  }

  Sitemap(): SDK<Sitemap> {
    return SDKFactory<Sitemap>(this.fsh.clientData, this.fsh.Schema.Sitemap_Beacons);
  }
}
